module.exports = __webpack_public_path__ + "static/media/Raavi.88057285.ttf";